var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4674",
    "data-name": "Group 4674",
    transform: "translate(-724 -660)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-logs-5072096",
    transform: "translate(714.121 487.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4673",
    "data-name": "Group 4673",
    transform: "translate(12.394 173.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660",
    transform: "translate(1.531 18.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13063",
    "data-name": "Path 13063",
    d: "M663.933,3215.007H648.774a.374.374,0,0,1-.374-.374v-2.26a.374.374,0,0,1,.747,0v1.886h14.412v-1.886a.374.374,0,0,1,.747,0v2.26A.374.374,0,0,1,663.933,3215.007Z",
    transform: "translate(-648.4 -3212)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4661",
    "data-name": "Group 4661",
    transform: "translate(1.531 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13064",
    "data-name": "Path 13064",
    d: "M663.933,187.74a.374.374,0,0,1-.374-.374v-8.5h-3.813a.374.374,0,0,1-.374-.374v-3.742H649.147v12.619a.374.374,0,0,1-.747,0V174.374a.374.374,0,0,1,.374-.374h10.973a.374.374,0,0,1,.374.374v3.741h3.813a.374.374,0,0,1,.374.374v8.878A.374.374,0,0,1,663.933,187.74Z",
    transform: "translate(-648.4 -174)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4662",
    "data-name": "Group 4662",
    transform: "translate(12.504 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13065",
    "data-name": "Path 13065",
    d: "M2430.17,178.773a.372.372,0,0,1-.262-.107l-4.186-4.115a.374.374,0,0,1,.524-.533l4.186,4.115a.374.374,0,0,1-.262.64Z",
    transform: "translate(-2425.61 -173.91)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4663",
    "data-name": "Group 4663",
    transform: "translate(0 12.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13066",
    "data-name": "Path 13066",
    d: "M418.688,2284.712H401.279a.78.78,0,0,1-.779-.779v-4.954a.78.78,0,0,1,.779-.779h17.409a.78.78,0,0,1,.779.779v4.954A.781.781,0,0,1,418.688,2284.712Zm-17.409-5.764a.032.032,0,0,0-.031.031v4.954a.032.032,0,0,0,.031.031h17.409a.032.032,0,0,0,.031-.031v-4.954a.032.032,0,0,0-.031-.031Z",
    transform: "translate(-400.5 -2278.2)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4664",
    "data-name": "Group 4664",
    transform: "translate(12.078 7.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13067",
    "data-name": "Path 13067",
    d: "M2357.019,1313.97a.373.373,0,0,1-.27-.632l1.221-1.281-1.221-1.281a.374.374,0,1,1,.541-.516l1.468,1.539a.373.373,0,0,1,0,.516l-1.468,1.539A.372.372,0,0,1,2357.019,1313.97Z",
    transform: "translate(-2356.646 -1310.146)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665",
    transform: "translate(4.674 7.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13068",
    "data-name": "Path 13068",
    d: "M1159.416,1314.07a.374.374,0,0,1-.27-.115l-1.468-1.539a.373.373,0,0,1,0-.516l1.468-1.539a.374.374,0,1,1,.541.516l-1.221,1.281,1.221,1.281a.373.373,0,0,1-.271.631Z",
    transform: "translate(-1157.575 -1310.246)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4666",
    "data-name": "Group 4666",
    transform: "translate(8.462 6.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13069",
    "data-name": "Path 13069",
    d: "M1771.44,1260.658a.381.381,0,0,1-.122-.02.374.374,0,0,1-.231-.475l1.3-3.745a.374.374,0,1,1,.706.245l-1.3,3.745A.374.374,0,0,1,1771.44,1260.658Z",
    transform: "translate(-1771.066 -1256.166)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4672",
    "data-name": "Group 4672",
    transform: "translate(4.526 14.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4669",
    "data-name": "Group 4669",
    transform: "translate(6.179 0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4667",
    "data-name": "Group 4667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13070",
    "data-name": "Path 13070",
    d: "M2136.2,2500.606a1.9,1.9,0,1,1,1.56-2.993.374.374,0,1,1-.613.428,1.155,1.155,0,1,0,.154,1.015.374.374,0,1,1,.712.228,1.9,1.9,0,0,1-1.813,1.323Z",
    transform: "translate(-2134.3 -2496.8)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4668",
    "data-name": "Group 4668",
    transform: "translate(1.729 1.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13071",
    "data-name": "Path 13071",
    d: "M2415.934,2820.947h-1.261a.374.374,0,0,1,0-.747h1.261a.374.374,0,0,1,0,.747Z",
    transform: "translate(-2414.3 -2820.2)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4670",
    "data-name": "Group 4670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13072",
    "data-name": "Path 13072",
    d: "M1135.443,2499.618h-1.569a.374.374,0,0,1-.374-.374v-3.071a.374.374,0,0,1,.747,0v2.7h1.2a.374.374,0,0,1,0,.748Z",
    transform: "translate(-1133.5 -2495.8)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4671",
    "data-name": "Group 4671",
    transform: "translate(2.326 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13073",
    "data-name": "Path 13073",
    d: "M1511.931,2500.918a1.642,1.642,0,0,1-1.24-.576,2.054,2.054,0,0,1,0-2.666,1.623,1.623,0,0,1,2.48,0,2.054,2.054,0,0,1,0,2.666A1.647,1.647,0,0,1,1511.931,2500.918Zm0-3.071a1.178,1.178,0,1,0,.984,1.162A1.085,1.085,0,0,0,1511.931,2497.847Z",
    transform: "translate(-1510.2 -2497.1)",
    fill: "#212a42",
    stroke: "#212a42",
    strokeWidth: 0.3
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1310",
    "data-name": "Rectangle 1310",
    width: 24,
    height: 24,
    transform: "translate(724 660)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsLogo);
export default __webpack_public_path__ + "static/media/logs-logo.20d3f29fac002d8103feafcb070f9cea.svg";
export { ForwardRef as ReactComponent };